export default __webpack_public_path__ + "static/media/amazon-pay.9cb2f24a.svg";